import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
    Input,
    Row,
    Card,
    Form,
    Col,
    Divider,
    Spin,
    Typography,
    Select,
    DatePicker,
} from "antd";


//PROJECT IMPORTS
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant"
import { BOM } from "../../../services/definedMethod";
import dayjs from "dayjs";
import { apiConfig, labelConfig, staticConfig } from "../group.config";


const { Text, Title } = Typography;
const dateFormat = 'YYYY/MM/DD';

const EditGroup = (props) => {
    //DECLARED VARIABLES
    const {
        userData,
    } = props;
    const { session } = userData;
    const navigate = useNavigate();
    const { state } = useLocation();
    const [staffOptions, setStaffOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [useForm] = Form.useForm();
    const [groupDetails, setGroupDetails] = useState([]);
    const [staffIsEmpty, setStaffIsEmpty] = useState();

    useEffect(() => {
        getStaffOptions();
        getDetailById();
    }, []);


    function onCancel() {
        navigate("/manage-group", { replace: false });
    }

    const getStaffOptions = () => {

        const url = `${apiConfig.Groups}/${state.id}`;
        const params = {
            associations: "clientMembers",
            staffInSelectedOfficeOnly: true,
            template: true,
        }
        let body = {
            session,
            params,
        };

        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                setIsLoading(false);
            } else {
                const objDetail = res;
                let tempStaffOptions = [];

                objDetail?.staffOptions?.forEach((element) => {
                    tempStaffOptions.push({
                        value: element.id,
                        label: element.displayName,
                    });
                });

                setStaffOptions(tempStaffOptions);
                setIsLoading(false);
            }
        });
    };

    const getDetailById = () => {

        const url = `${apiConfig.Groups}/${state.id}`;
        const params = {
            associations: "clientMembers",
            staffInSelectedOfficeOnly: true,
            template: true,
        }
        let body = {
            session,
            // params,
        };

        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                setIsLoading(false);
            } else {
                const objDetail = res;
                setGroupDetails(objDetail);

                // SHOW THE SAVED DATA
                useForm.setFieldsValue({
                    name: objDetail?.name,
                    staffId: objDetail?.staffId,
                    activationDate: objDetail?.timeline?.activatedOnDate
                        ? dayjs(BOM.FormatArrayDate(objDetail?.timeline?.activatedOnDate))
                        : objDetail?.timeline?.activatedOnDate,
                    submittedOnDate: objDetail?.timeline?.submittedOnDate
                        ? dayjs(BOM.FormatArrayDate(objDetail?.timeline?.submittedOnDate))
                        : objDetail?.timeline?.submittedOnDate,
                    externalId: objDetail?.externalId,
                });

                setIsLoading(false);
            }
        });
    };

    const disabledAfterCurrentDate = (current) => {
        return current && current.valueOf() > Date.now();
    };
    const handleStaffChange = (value) => {
        if (!value) {
            setStaffIsEmpty(null);
        }
    };
    const onSubmit = (formValues) => {

        formValues.submittedOnDate = BOM.DateTime(formValues.submittedOnDate, "only-date");
        formValues.activationDate = BOM.DateTime(formValues.activationDate, "only-date");
        formValues.staffId = staffIsEmpty === null ? staffIsEmpty : formValues.staffId

        const url = `${apiConfig.Groups}/${state.id}`;

        const body = {
            ...formValues,
            locale: "en",
            dateFormat: "dd MMMM yyyy",
            method: "PUT",
            session,
        };
        // console.log(body);
        // return;

        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
                setIsLoading(false);
            } else {
                BOM.AlertMsg(cnt.SUCCESS, labelConfig.editGroupMsg);
                navigate("/manage-group");
                //STOP LOAD
                setIsLoading(false);
            }
        });
    };

    return (
        <MainLayout isEnableRightSidebar={false}>
            <TopContent
                pageTitle={labelConfig.editGroup}
                pageItems={staticConfig.editGroupBreadcrumbItems}
            />
            <Spin spinning={isLoading} size="large">
                <Card
                    headStyle={{ borderBottomWidth: 0 }}
                    style={{
                        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                        borderRadius: 20,
                    }}
                >
                    <Form
                        layout="vertical"
                        onFinish={onSubmit}
                        form={useForm}
                    >
                        <Row>
                            <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                                Group Setup
                            </Title>
                        </Row>
                        <Divider style={{ marginTop: 10, marginBottom: 30 }} />
                        <Row>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={<Text>{labelConfig.name}</Text>}
                                    name="name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Required Field",
                                        },
                                    ]}
                                >
                                    <Input placeholder="Name"></Input>
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={<Text>{labelConfig.staff}</Text>}
                                    name="staffId"
                                >
                                    <Select
                                        filterOption={(input, option) =>
                                            (option?.label?.toLowerCase() ?? "").includes(
                                                input?.toLowerCase()
                                            )
                                        }
                                        showSearch
                                        options={staffOptions}
                                        onChange={handleStaffChange}
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.staff,
                                            "select"
                                        )}
                                        allowClear
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={<Text>{labelConfig.externalID}</Text>}
                                    name="externalId"
                                >
                                    <Input placeholder="External ID" />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.submittedOn}
                                    name="submittedOnDate"
                                >
                                    <DatePicker
                                        disabledDate={disabledAfterCurrentDate}
                                        style={{ width: "100%", height: 32.5 }}
                                        format={dateFormat}
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.submittedOn,
                                            "select"
                                        )}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.activationDate}
                                    name="activationDate"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(labelConfig.activationDate),
                                        },
                                    ]}
                                >
                                    <DatePicker
                                        disabledDate={disabledAfterCurrentDate}
                                        style={{ width: "100%", height: 32.5 }}
                                        format={dateFormat}
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.activationDate,
                                            "select"
                                        )}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Divider />
                            {BOM.HasPermission("UPDATE_GROUP") &&
                                <CustomButton
                                    content="Submit"
                                    style={{
                                        width: "10%",
                                        marginLeft: "auto",
                                        boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                    }}
                                    htmlType="submit"
                                    backgroundColor="#92428B"
                                    colorText="white"
                                    hoverBackground="#AD4EA7"
                                />}
                            <CustomButton
                                content="Cancel"
                                style={{
                                    width: "10%",
                                    marginLeft: "1%",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                backgroundColor="#fff"
                                colorText="black"
                                hoverBackground="#F5F5F5"
                                onClick={onCancel}
                            />
                        </Row>
                    </Form>

                </Card>
            </Spin>
        </MainLayout >
    );
};

const mapStateToProps = (state) => ({
    userData: state.AuthenticationData.userData,
    rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EditGroup);

